module.exports = __webpack_public_path__ + "static/media/suggestion-analytics.3b9c1ee7.svg";